<template>
  <div class="justify-content-center">
    <b-button title="Voltar" pill variant="outline-secondary" @click="voltar">
      <font-awesome-icon type="submit" :icon="['fa', 'arrow-left']" />
      Voltar
    </b-button>
    <div class="mt-2 mb-2 d-flex justify-content-center">
      <div class="line"></div>
      <div style="margin-top: 0.5rem">
        <h5>
          <strong>{{ tituloPrincipal }}</strong>
        </h5>
      </div>
      <div class="line"></div>
    </div>
    <h5 align="left" class="mt-4 mb-2">
      <strong>{{ titulo }}</strong>
    </h5>
    <b-row class="mb-3">
      <b-col>
        <b-card class="shadow border-white">
          <FiltroMultaPlacaRenavamComponent
            ref="FiltroMultaPlacaRenavamComponent"
            @pesquisar="pesquisar"
            @limpar="limpar"
            :filtroDefault="filtroPesquisa"
          ></FiltroMultaPlacaRenavamComponent>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <TabelaConsultaMultaComponent
          ref="TabelaConsultaMultaComponent"
          :filtro="filtro"
          :exibirPlaca="false"
          :exibirResultado="exibirResultado"
          @abrirModal="abrirModal"
          @alterarExibicaoResultado="alterarExibicaoResultado"
        ></TabelaConsultaMultaComponent>
      </b-col>
    </b-row>
    <b-modal
      v-model="modalShow"
      centered
      hide-footer
      id="modal-lg"
      size="xl"
      ref="modal"
    >
      <div>
        <b-embed
          type="iframe"
          aspect="21by9"
          :src="imgMidia"
          allowfullscreen
        ></b-embed>
      </div>
    </b-modal>
  </div>
</template>
<script>
import FiltroMultaPlacaRenavamComponent from "@/components/FiltroMultaPlacaRenavamComponent";
import TabelaConsultaMultaComponent from "./TabelaConsultaMultaComponent";
import FiltroMulta from "@/models/FiltroMulta.js";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ConsultaMultaViewPlacaRenavam",

  components: {
    FiltroMultaPlacaRenavamComponent,
    TabelaConsultaMultaComponent,
  },

  props: {
    parametrosProp: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  data() {
    return {
      titulo: "Consulta por Placa e RENAVAM",
      tituloPrincipal:
        "MULTA DE TRÂNSITO emitida pela Prefeitura de Belo Horizonte",
      filtro: new FiltroMulta(),
      exibirResultado: false,
      imgMidia: null,
      tipoResource: null,
      modalShow: false,
    };
  },

  computed: {
    ...mapGetters(["filtroPesquisa"]),
  },

  methods: {
    ...mapMutations(["setFiltroPesquisa"]),

    pesquisar(filtro) {
      if (filtro.placa && filtro.renavam) {
        this.filtro = filtro;
        this.setFiltroPesquisa(this.filtro);
        this.exibirResultado = true;
        this.$nextTick(() => {
          this.$refs.TabelaConsultaMultaComponent.listar();
          //this.$refs.FiltroMultaPlacaRenavamComponent.limparRecaptcha();
        });
      }
    },

    voltar() {
      this.$router.push({
        name: "ConsultaMultaView",
      });
    },

    limpar() {
      this.exibirResultado = false;
    },

    alterarExibicaoResultado() {
      this.exibirResultado = true;
    },

    setFiltroDefault() {
      if (this.filtroPesquisa && Object.keys(this.filtroPesquisa).length > 0) {
        this.filtro = JSON.parse(JSON.stringify(this.filtroPesquisa));
      }
    },
    
    abrirModal(tipoResource, imgMidia) {
      this.tipoResource = tipoResource;
      this.imgMidia = imgMidia;
      this.modalShow = true;
    },
  },
  created() {
    this.setFiltroDefault();
  },

  mounted() {
    //this.pesquisar(this.filtro);
  },
};
</script>

<style scoped>
</style>